// Texts that carry the customer placeholder, verbatim from the Proship Messenger mockup
// (docs/mockups/messenger-in-proship/app.js: BC_PREFILL, BC_SAMPLE). They stay out of locales/*.js
// because vue-i18n reads braces as parameters.

export const NAME_CHIP = "{{ชื่อ}}"; // what the seller types / sees
export const NAME_TOKEN = "{{name}}"; // what the API fills per customer

export const PREFILL = {
  tracked: "{{ชื่อ}} กล่องของคุณยังไม่ปิดนะคะ 📦 อยากแอบใส่อะไรเพิ่ม พิมพ์ชื่อของมาเลย ส่งกล่องเดียวกัน",
  ordered: "{{ชื่อ}} กล่องของคุณยังไม่ปิดนะคะ 📦 อยากแอบใส่อะไรเพิ่ม พิมพ์ชื่อของมาเลย ส่งกล่องเดียวกัน",
  interested: '{{ชื่อ}} ตัวที่ถามไว้ แม่ค้าแอบซ่อนไว้หลังร้านถึงสองทุ่ม 🙈 พิมพ์ "เอา" คำเดียวจบ',
  one_message: "ขี้เกียจพิมพ์ใช่ไหม{{ชื่อ}} 😆 ตอบเลขเดียวพอ: 1 ดูรูปจริง 2 ถามราคา 3 ขอโปรวันนี้",
  all: 'คนที่ทักวันนี้ได้ดูก่อนใคร 🔥 ล็อตใหม่เข้าพรุ่งนี้ ตอบ "จอง" แม่ค้ากันไว้ให้ก่อนลงโพสต์',
};

export const SAMPLE = { name: "สมชาย", order: "PS-261016-0220" };

// The home sample bubble: the ทุกคน prefill line with the sample name
export const homeSample = () => PREFILL.all.split(NAME_CHIP).join(SAMPLE.name);

// Group keys are the API's (groups[0]); order is the mockup's
export const GROUPS = ["tracked", "ordered", "interested", "one_message", "all"];
export const POST_SALE_GROUPS = ["tracked", "ordered"];

// Whole-inbox message kinds: the three ProShip templates (key) and the seller's own
export const ITYPES = [
  { key: "after", templateKey: "order_status" },
  { key: "account", templateKey: "account_update" },
  { key: "event", templateKey: "event_update" },
  { key: "own", templateKey: null },
];

export const newKey = () => {
  const c = typeof window !== "undefined" ? window.crypto : null;
  if (c && c.randomUUID) return c.randomUUID();
  const bytes = new Uint8Array(16);
  if (c && c.getRandomValues) c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  return Array.prototype.map.call(bytes, (b) => ("0" + b.toString(16)).slice(-2)).join("");
};

// Split text into [{t, kind}] so placeholders and filled values can be coloured.
// marks: [{ token, kind }] kind = name | slot | faint
export const splitMarks = (text, marks) => {
  let parts = [{ t: String(text || ""), kind: "" }];
  marks.forEach((mark) => {
    if (!mark.token) return;
    const next = [];
    parts.forEach((part) => {
      if (part.kind) return next.push(part);
      const pieces = part.t.split(mark.token);
      pieces.forEach((piece, i) => {
        if (piece) next.push({ t: piece, kind: "" });
        if (i < pieces.length - 1) next.push({ t: mark.show == null ? mark.token : mark.show, kind: mark.kind });
      });
    });
    parts = next;
  });
  return parts;
};

